<template>
  <p class="h4" data-test="h4">
    <slot>{{ title }}</slot>
  </p>
</template>

<script>
export default {
  name: 'BlueTitle',
  props: {
    title: String,
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';

.h4 {
  margin: 0;
  box-sizing: border-box;
  margin-left: 20px;
  height: 18px;
  font-size: 16px;
  color: @font-color-black;
  .flex_layout(row, flex-start);
  &::before {
    content: '';
    display: inline-block;
    width: 3px;
    height: 100%;
    margin-right: 0.5em;
    background-color: @primary-blue;
  }
}
</style>
